export const getApiCancelKeys = (payload?: {
  cancelKey?: string;
  cancelKeys?: string[];
}): string[] => {
  if (!payload) {
    return [];
  }

  if (payload.cancelKeys) {
    return payload.cancelKeys;
  }

  return payload.cancelKey ? [payload.cancelKey] : [];
};

export const matchesApiCancelKey = (
  payload: { cancelKey?: string; cancelKeys?: string[] } | undefined,
  cancelKey: string
): boolean => getApiCancelKeys(payload).includes(cancelKey);
